<div class="flex flex-col gap-6 py-8" *transloco="let t">
  <h4>
    {{ t("common.audiences") }}
    @if (isAwareness()) {
      <span class="type-label text-muted-foreground">({{ t("common.optional") | titlecase }})</span>
    }
  </h4>

  @if (!isAwareness()) {
    <app-dsp-audience-preset-selector
      [audiencePreset]="audiences().audiencePreset().value()"
      (audiencePresetChange)="selectAudiencePreset($event)"
    />
  }

  @if (isManualPreset()) {
    <div class="flex flex-col gap-2">
      @if (isAwareness()) {
        <div class="type-label text-muted-foreground">
          {{ t("common.audiences") }} ({{ t("common.optional") | titlecase }})
        </div>
      }
      <app-dsp-audiences-selector
        [selectedAudiences]="audiences().audiences().value()"
        (selectedAudiencesChange)="selectAudiences($event)"
        [audienceType]="StrategyDspAudienceType.WHITELIST"
      />
    </div>

    <div class="flex flex-col gap-2">
      <div class="type-body-medium text-foreground">
        {{ t("dsp-strategy-page.audience_blacklist") }}
        <span class="type-label text-muted-foreground">({{ t("common.optional") | titlecase }})</span>
      </div>
      <app-dsp-audiences-selector
        [selectedAudiences]="audiences().blacklistedAudiences().value()"
        (selectedAudiencesChange)="selectBlacklistedAudiences($event)"
        [audienceType]="StrategyDspAudienceType.BLACKLIST"
      />
    </div>
  } @else {
    <app-dsp-smart-audience-selector
      [selectedPreset]="audiences().audiencePreset().value()"
      (selectedPresetChange)="selectAudiencePreset($event)"
    />
  }
</div>
